export const maxCountBetweenChars = (charCount, value) => {
    if (!value) {
        return 0;
    }
    let max = 0;
    let currentCount = 0;
    let insideSequence = false;
    for (const char of value) {
        if (char === charCount) {
            if (insideSequence) {
                max = Math.max(max, currentCount);
                currentCount = 0;
            }
            insideSequence = true;
        }
        else if (insideSequence) {
            currentCount++;
        }
    }
    max = Math.max(max, currentCount);
    return max;
};
// The function is designed to convert a duration value, which could be a string or a number, into a numeric value representing milliseconds
// If duration is already a number, it simply returns the number.
export const convertDurationToNumber = (duration) => {
    if (!duration) {
        return 0;
    }
    if (typeof duration === 'number') {
        return duration;
    }
    // Remove "ms" or "s" from the duration and convert it to a number
    const value = Number(duration.replace('ms', '').replace('s', ''));
    // If the duration was in seconds, convert it to milliseconds
    if (duration.includes('s') && !duration.includes('ms')) {
        return value * 1000;
    }
    return value;
};
//# sourceMappingURL=string.utility.js.map